// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__IF7xp","clinicsSelect":"TableHeading_clinicsSelect__26DHP"};